import React from 'react'

import { Form, Col } from '_zari/core'

const FechaEmisionFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='FECHA EMISION' md={4} />
      <Col md={8}>
        <Form.InputText value={iValue} id='input-fechaEmision' disabled />
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaEmisionFormGroup)
